import React, { Component } from 'react';
import * as $ from 'jquery';
import Invoice from '../../dashboard/invoices/Invoice.js';
import Invoices from '../../dashboard/invoices/Invoices.js';
import axios from 'axios';
import moment from 'moment-timezone';
import { MENU } from '../../dashboard/Sidebar.js';
import { translate } from 'react-i18next';
import { ERRORS } from '../../App.js';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';

export const STATUS = {
  PENDING: 1,
  PAID: 2,
  PROCESS: 3
};

let cancelToken;
let state;
let tokenSession;

class ExternalPaymentContainer extends Component {

  constructor(props) {
    super(props);
    const init_state = {
      error: "",
      invoice: null,
      invoices: [],
      pdf: "",
      xml: "",
      get_data_invoices: [],
      get_data_invoives_page: [],
      pay_invoice: false,
      total_invoices: 0,
    };
    this.state = init_state;
  }

  componentDidMount(){
    //si el script de prosa ya cargo para cierto checkout id, no se puede reutilizar y cargar para otro ID, por eso hay que eliminar el script si ya existe
    var script = document.getElementById("prosaCheckout");
    if(script){
       console.log("script existed and removed");
        $( script ).remove();
    }
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    if(this.state.invoices.length == 0){
      this.getPendingInvoices({
        token_id: this.props.getTokenId(),
        folio_externo: this.props.match.params.external_token
      });
    }
  }

  getPendingInvoices = (params) => {
    const { t } = this.props;
    this.props.post(
      "/getPendingInvoices",
      params,
      (response) => this.didGetPendingInvoices(response),
      (error) => {
        this.setState({ error: t('dashboard.invoices.no_results') });
        this.handlePendingInvoicesErrorResponse(error);
      },
      cancelToken
    );
  }

  didGetPendingInvoices = (response) => {
    const { t } = this.props;

    const callback = () => {
      if (this.state.invoices.length > 0) {
        $('html, body').animate({
          scrollTop: $('#invoices').offset().top - $('.navbar').height() - 20
        }, 800);
        this.getInvoiceDocuments(this.state.invoice.id);
      } else {
        this.setState({ error: t('dashboard.invoices.no_pending_found') });
      }
    };

    let balance_mxn = 0;
    let balance_mxn_solucion = 0;
    response.map((invoice) => {
        balance_mxn_solucion = balance_mxn + invoice.balance_mxn;
        if (balance_mxn_solucion <= 190000 && invoice.status == 1) {
          this.state.get_data_invoices.push(invoice)
          invoice.checked = true;
          balance_mxn += invoice.balance_mxn
          this.state.get_data_invoives_page.push(invoice)
          this.setState({
            pay_invoice: true,
            total_invoices:balance_mxn,
          });
        }
    })


    this.setState({
      invoice: response[0],
      invoices: response,
      pdf: "",
      xml: ""
    }, callback);
  }

  handleInvoiceViewClick = (invoice) => {
    console.log(invoice)
    this.setState({
      invoice: invoice,
      pdf: "",
      xml: ""
    }, () => this.getInvoice(invoice.id));
  }

  handlePendingInvoicesErrorResponse = (error) => {
    const { t } = this.props;
    alert(t('app.error_unknown'));
  }

  handleInvoiceClick = (invoice) => {
    try {
      let balance_mxn = this.state.total_invoices;
      const get_data_invoives_page = this.state.get_data_invoives_page.indexOf(invoice)
      const get_data_invoices = this.state.get_data_invoices.indexOf(invoice)
      if (get_data_invoives_page > -1 || get_data_invoices > -1) {
        if (this.state.get_data_invoives_page.length > 1) {
          this.state.get_data_invoives_page.splice(get_data_invoives_page, 1)
          this.state.get_data_invoices.splice(get_data_invoices, 1)
          balance_mxn -= invoice.balance_mxn
          invoice.checked = false;
        } else {
          alert("Favor de Selecionar una Factura")
        }
      } else {
        //console.log(balance_mxn);
        const balance_mxn_solucion = this.state.total_invoices + invoice.balance_mxn
        if (balance_mxn_solucion <= 190000) {
          this.state.get_data_invoives_page.push(invoice)
          this.state.get_data_invoices.push(invoice)
          balance_mxn += invoice.balance_mxn
          invoice.checked = true;
        } else {
          alert("La selección supera el monto máximo permitido por transacción")
        }
      }
      this.setState({
        total_invoices: balance_mxn
      })
    } catch (error) {
      console.error(error);
    }  
  }


  getInvoiceDocuments = (invoiceId) => {
    this.getPdf({
      factura_id: invoiceId,
      token_id: this.props.getTokenId(),
      folio_externo: this.props.match.params.external_token
    });

    this.getXml({
      factura_id: invoiceId,
      token_id: this.props.getTokenId(),
      folio_externo: this.props.match.params.external_token
    });
  }

  getPdf = (params) => {
    this.props.post(
      "/facturas/pdf",
      params,
      (response) => this.didGetPdf(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetPdf = (response) => {
    this.setState({ pdf: response });
  }

  getXml = (params) => {
    this.props.post(
      "/facturas/xml",
      params,
      (response) => this.didGetXml(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetXml = (response) => {
    this.setState({ xml: response });
  }

  renderInvoice = () => {
    return(
      <Invoice
        key={this.state.invoice.id}
        pdf={this.state.pdf}
        xml={this.state.xml} />
    );
  }

  renderInvoices = () => {
    return(
      <Invoices
        handleInvoiceViewClick={this.handleInvoiceViewClick}
        handleInvoiceClick={this.handleInvoiceClick}
        invoice={this.state.invoice}
        invoices={this.state.invoices}
        get_data_invoices={this.state.get_data_invoices}
        get_data_invoives_page={this.state.get_data_invoives_page}
        total_invoices={this.state.total_invoices}
        pay_invoice={this.state.pay_invoice}
        isExternal={true}
        folio_externo= {this.props.match.params.external_token} />
    );
  }

  renderError = () => {
    return(
      <div className="form-group">
        <div className="col-sm-8 col-sm-offset-2">
          <div className="alert alert-warning">
            {this.state.error}
          </div>
        </div>
      </div>
    );
  }
  
  render() {
    const { t } = this.props;

    return(
      <div>
        {this.renderNavbar()}
        <h2 className="page-header" style={{paddingTop: "3%",paddingLeft: "5%"}}>{t('dashboard.invoices.heading_pending')}</h2>
        <div style={{paddingLeft: "5%",paddingRight: "5%"}}>
          {this.state.error && this.renderError() }
          {this.state.invoices.length > 0 && this.renderInvoices()}
          {this.state.invoice && this.renderInvoice()}
        </div>
        <div style={ this.state.error ? footer_bottom : {}}>{this.renderFooter()}</div>
      </div>
    );
  }

  renderFooter = () => {
      return(
          <Footer />
      );
  }

  renderNavbar = () => {
      return(
          <Navbar
          handleLanguageChange={this.props.handleLanguageChange}
          lang={this.props.lang} />
      );
  }


}


export default compose(
  translate('common'),
  withRouter
)(ExternalPaymentContainer);



const footer_bottom = {
  position: 'absolute',
  bottom: 0,
  width: '100%'
}



// WEBPACK FOOTER //
// ./src/guest/payment/ExternalPaymentContainer.js